module.exports = __webpack_public_path__ + "components/flag/static/square/st-95ec25640c911126b02be4702192c98b.svg";